import { render } from "./TaskDetails.vue?vue&type=template&id=b9cc7ce0"
import script from "./TaskDetails.vue?vue&type=script&lang=js"
export * from "./TaskDetails.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./TaskDetails.vue?vue&type=style&index=0&id=b9cc7ce0&module=true&lang=scss"
cssModules["$style"] = style0

import exportComponent from "/home/runner/work/pulse/pulse/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__